import odin, { Secrets } from '@odinjs/odin';
import { subscribeToHmrModuleChanges } from '@philips-internal/oswald-ui-utils';
import MetaValidator, { validateLocales } from '../utils/meta-validator.js';
import { findStackTraceEntryOfDecorator } from '../utils/stack-trace.js';
const _isController = Symbol('controller-def');
const _fragment = Symbol('fragment');
const _component = Symbol('component');
const _locales = Symbol('locales');
const paramsValidator = MetaValidator.create()
    .str('component', false)
    .str('fragment', true)
    .custom('locales', false, validateLocales)
    .validator();
function Controller(args) {
    return ControllerDecorator(args);
}
function ControllerDecorator(definition, args) {
    const validate = MetaValidator.validateDecorator(ControllerDecorator, paramsValidator, definition, args);
    if (validate) {
        return validate;
    }
    const { fragment: domain = '', locales, component: name = null, } = args || {};
    Secrets.setCustom(definition);
    Secrets.setSingleton(definition);
    Secrets.setDiscardable(definition);
    setter(definition, _isController, true);
    setter(definition, _fragment, domain);
    setter(definition, _component, name);
    setter(definition, _locales, locales);
    return register(definition, domain, { name });
}
function setter(target, key, value) {
    target[key] = value;
}
function register(definition, domain, args) {
    const bundle = getOdinBundle(domain);
    bundle.register(definition, args);
    const module = findStackTraceEntryOfDecorator();
    subscribeToHmrModuleChanges(module, () => {
        bundle.unregister(definition, domain, args);
    });
    return definition;
}
function isController(definition) {
    return definition[_isController] === true
        || definition.constructor[_isController] === true;
}
function get(definition) {
    const target = definition.constructor;
    return {
        component: target[_component],
        fragment: target[_fragment],
        locales: target[_locales],
    };
}
// TODO: Odin: remove once odin fixes its build
function getOdinBundle(domain) {
    try {
        return odin.bundle(domain);
    }
    catch {
        return odin.default.bundle(domain);
    }
}
export { Controller as default, Controller, get, isController, };
//# sourceMappingURL=controller.js.map